import React, {Component} from 'react';
import ElementsHomePanel from '../ElementsHomePanel';
import {fetchIcons} from './actions.js';
import InfiniteScroll from "react-infinite-scroll-component";
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import DesignResourcesPanel from '../../components/designResourcesPanel';
import {Button, Form, FormControl, FormGroup, InputGroup} from 'react-bootstrap';
import {fetch_teams} from '../../views/BrandKit/actions';
import {toastr} from "react-redux-toastr";

var default_drag_ghost = new window.Image();
default_drag_ghost.id = 'drag_image'
default_drag_ghost.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=';

const PageSize = 20;

class ElementsPanel extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            page: 0,
            category: 'all',
            elementCategories: [],
            isFetching: true,
            searchActive: false,
            searchKeywords: '',
            bkResources: []
        }
    }

    handleSearchOnChange = (e) => {
        this.setState({
            searchKeywords: e.target.value
        })
    };

    fetchBrandKitLogos = async () => {
        try {
            if (this.props.user) {
                var user_details = await this.props.fetch_teams()
                if (user_details && user_details.own_teams[0] && user_details.own_teams[0].brand_kits[0]) {
                    var bkResources = user_details.own_teams[0].brand_kits[0].logos;
                    var bkLogos = {
                        type: 'brand_kit',
                        displayName: 'Brand Kit',
                        on_drag_start: this.props.image_drag_start,
                        on_drag: this.props.image_drag,
                        on_drag_end: this.props.image_drag_end,
                        on_click: this.props.add_image,
                        data: bkResources,
                        order: 0
                    }

                    return Promise.resolve(
                        this.setState({
                            elementCategories: this.state.elementCategories.concat([bkLogos]),
                            bkResources: bkResources
                        })
                    )
                }
                return this.set_state({user_details})
            } else {
                return Promise.resolve(null)
            }
        } catch (error) {
            return Promise.reject(error);
        }
    };

    fetchSearchResults = () => {

        const url = global.config.server_path + 'design_resources/_search?';
        const type = 'image';
        const subType = 'icon';

        const queryBody = {
            "from": (this.state.page * PageSize),
            "size": PageSize,
            "query": {
                "bool": {
                    "must": [{
                        "multi_match": {
                            "query": this.state.searchKeywords,
                            "fields": ["name", "keywords"],
                            "operator": "or",
                            "type": "best_fields",
                        }
                    }],
                    "filter": [
                        {
                            "terms": {
                                "type.keyword": [type]

                            }
                        },
                        {
                            "terms": {
                                "sub_type.keyword": [subType]

                            }
                        }
                    ]
                }
            }
        };

        fetch(url, {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(queryBody)})
            .then(resp => resp.json())
            .then(resp => resp.hits.hits.map(x => x._id))
            .then(resp => {
                const url = global.config.server_path + 'design_resource/get/';
                const payload = {
                    id: resp,
                    'type': type,
                    'sub_type': subType
                };
                return fetch(url, {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json'},
                    'credentials': 'include',
                    body: JSON.stringify(payload)
                })
            })
            .then(resp => resp.json())
            .then(data => {
                data = data.data.docs;
                if (data) {
                    this.setState({
                        data: this.state.data.concat(data),
                        page: this.state.page + 1
                    })
                }
            })
            .catch(error => console.error(error))
    };

    handleSearchClear = () => {
        this.setState({
            data: [],
            searchActive: false,
            searchKeywords: '',
            page: 0
        }, this.fetchData)
    };

    handleSearchSubmit = (e) => {
        e.preventDefault();
        this.setState({
            data: [],
            searchActive: true,
            page: 0
        }, this.fetchSearchResults)
    };

    componentDidMount() {
        Promise.all([
            this.fetchBrandKitLogos(),
            this.fetchGrids(),
            this.fetchFrames(),
            this.fetchIcons()
        ])
            .then(() => {
                let sortedCategories = this.state.elementCategories.sort(function (a, b) {
                    return a.order - b.order
                });
                this.setState({elementCategories: sortedCategories})
            })
            .then(() => this.setState({isFetching: false}))
            .catch(err => console.log(err));
    }

    fetchGrids = async () => {
        try {
            const gridResources = window.getGridResources(0, 20);
            const grids = {
                type: 'grid',
                displayName: 'Grids',
                on_drag_start: this.grid_drag_start,
                on_drag: this.grid_drag,
                on_drag_end: this.grid_drag_end,
                on_click: this.add_grid,
                data: gridResources,
                order: 1
            };

            return Promise.resolve(
                this.setState({
                    elementCategories: this.state.elementCategories.concat([grids])
                })
            )
        } catch (error) {
            console.error("Error loading grids");
            toastr.error("Something went wrong");
            return Promise.reject(error);
        }
    };

    fetchFrames = async () => {

        try {

            const options = {
                type: 'image',
                sub_type: 'frame',
                page_no: 0,
                size: 20
            };

            return fetch(global.config.server_path + 'design_resource/get/',
                {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'include',
                    body: JSON.stringify(options)
                }
            )
                .then(resp => resp.json())
                .then(data => {
                    data = data.data.docs;
                    const frames = {
                        type: 'frame',
                        displayName: 'Masks',
                        on_drag_start: this.frame_drag_start,
                        on_drag: this.frame_drag,
                        on_drag_end: this.frame_drag_end,
                        on_click: this.add_frame,
                        data: data,
                        order: 2

                    };

                    return Promise.resolve(
                        this.setState({
                            elementCategories: this.state.elementCategories.concat([frames])
                        })
                    )
                })
                .catch(error => {
                    console.log(error);
                    return Promise.reject(error)
                })
        } catch (error) {
            console.error("Error fetching and loading frames");
            toastr.error("Something went wrong");
            Promise.reject(error);
        }
    };

    fetchIcons = async () => {

        try {
            return fetchIcons()
                // .then(data => data.json())
                .then(data => {
                    data = data.data;
                    let icons = {};
                    let iconNameIdMap = {};
                    for (let i = 0; i < data.length; i++) {
                        icons[data[i].name] = data[i];
                        iconNameIdMap[data[i].name] = data[i]._id;
                    }

                    let iconData = [];
                    let counter = 0;
                    for (let key in icons) {
                        iconData.push(
                            {
                                type: icons[key].name,
                                displayName: icons[key].name,
                                on_drag_start: this.icon_drag_start,
                                on_drag: this.icon_drag,
                                on_drag_end: this.icon_drag_end,
                                on_click: this.add_icon,
                                data: icons[key].data,
                                order: counter + 3
                            }
                        );

                        counter += 1;
                    }

                    return Promise.resolve(
                        this.setState({
                            iconNameIdMap: iconNameIdMap,
                            elementCategories: this.state.elementCategories.concat(iconData)
                        })
                    )
                })
        } catch (error) {
            console.error("Error fetching and loading icons");
            toastr.error("Something went wrong");
            return Promise.reject(error)
        }
    };

    fetchElementResources = (sub_type, page_no, size, category_id) => {
        let payload = {
            type: 'image',
            sub_type: sub_type,
            page_no: page_no,
            size: size,
            category_id: category_id
        };

        return fetch(global.config.server_path + 'design_resource/get/', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            'credentials': 'include',
            body: JSON.stringify(payload)
        }).then(resp => resp.json()).then(resp => resp.data.docs)
    };

    fetchData = (category) => {
        if (!category) category = this.state.category;
        if (category == 'frame') {
            this.fetchElementResources('frame', this.state.page, 40)
                .then(data => {
                    this.setState({
                        data: this.state.data.concat(data),
                        page: this.state.page + 1
                    })
                })
                .catch(error => console.error(error))
        } else if (category == 'grid') {
            const newGridResources = window.getGridResources(this.state.page, 40);
            this.setState({
                data: this.state.data.concat(newGridResources),
                page_no: this.state.page + 1
            })
        } else if (category == 'brand_kit') {
            const bkResources = this.state.bkResources
            this.setState({
                data: bkResources,
                page_no: 0
            })
        } else {
            this.fetchElementResources('icon', this.state.page, 20, this.state.iconNameIdMap[category])
                .then(data => {
                    this.setState({
                        data: this.state.data.concat(data),
                        page: this.state.page + 1
                    })
                })
                .catch(error => console.error(error))
        }
    }

    icon_drag_start = (resource, event) => {
        return; //temp return
        var x, y;
        if (event.type == "touchmove") {
            x = event.touches[0].pageX;
            y = event.touches[0].pageY;
        } else {
            x = event.pageX;
            y = event.pageY;
        }

        var offset_x = (x - window.$(event.target).offset().left)
        var offset_y = (y - window.$(event.target).offset().top)


        event.dataTransfer.effectAllowed = 'move';
        event.target.style.opacity = 0

        event.dataTransfer.setDragImage(default_drag_ghost, 0, 0);

        window.design_editor.drag_ghost_image = event.target.cloneNode(true);
        window.design_editor.drag_ghost_image.style.opacity = 0.8
        window.document.body.appendChild(window.design_editor.drag_ghost_image)
        window.design_editor.drag_details = {
            offset_x: offset_x,
            offset_y: offset_y,
            raw_x: x,
            raw_y: y,
            previous_raw_x: x,
            previous_raw_y: y,
            original_width: event.target.clientWidth,
            original_height: event.target.clientHeight,
            drag_type: 'image',
            data: {
                type: 'image',
                sub_type: 'icon',
                data: {resource_id: resource._id}
            }
        }
    };

    icon_drag = (resource, event) => {
        return; //temp return
        var x, y;
        if (event.type == "touchmove") {
            x = event.touches[0].pageX;
            y = event.touches[0].pageY;
        } else {
            x = event.pageX;
            y = event.pageY;
        }
        if (window.design_editor.drag_details) {
            window.design_editor.drag_details.raw_x = window.design_editor.drag_details.previous_raw_x
            window.design_editor.drag_details.raw_y = window.design_editor.drag_details.previous_raw_y
            window.design_editor.drag_details.previous_raw_x = x
            window.design_editor.drag_details.previous_raw_y = y
        }

        window.design_editor.style_ghost_image(event.target);

        event.preventDefault();
    }

    icon_drag_end = (resource, event) => {
        return; //temp return
        event.target.style.opacity = 1
        var elem = window.document.getElementById('drag_image');
        if (elem && elem.parentElement) {
            elem.parentElement.removeChild(elem);
        }
        if (window.design_editor.drag_ghost_image && window.design_editor.drag_ghost_image.parentElement) {
            window.design_editor.drag_ghost_image.parentElement.removeChild(window.design_editor.drag_ghost_image);
        }

        window.design_editor.handleDrop(event.target);
        // window.design_editor.drag_ghost_image = null;
        // window.design_editor.drag_details = null;
        event.preventDefault();
    };

    add_icon = (resource, event) => {
        var aspect = event.target.clientWidth / event.target.clientHeight
        var width = window.design_editor.design.get_width() * 400 / 800
        window.design_editor.addObject({
            type: 'image',
            sub_type: 'icon',
            image_details: {
                resource_id: resource._id,
                image_width: width,
                image_height: width / aspect
            },
            width: width,
            height: width / aspect,
            loader_image: event.target
        })
    };

    add_grid = (resource) => {
        window.design_editor.addObject(resource.design_file)
    };

    grid_drag_start = (resource, event) => {
        return; //temp return
        var x, y;
        if (event.type == "touchmove") {
            x = event.touches[0].pageX;
            y = event.touches[0].pageY;
        } else {
            x = event.pageX;
            y = event.pageY;
        }

        var offset_x = (x - window.$(event.target).offset().left)
        var offset_y = (y - window.$(event.target).offset().top)


        event.dataTransfer.effectAllowed = 'move';
        event.target.style.opacity = 0

        event.dataTransfer.setDragImage(default_drag_ghost, 0, 0);

        window.design_editor.drag_ghost_image = event.target.cloneNode(true);
        window.design_editor.drag_ghost_image.style.opacity = 0.8
        window.document.body.appendChild(window.design_editor.drag_ghost_image)
        window.design_editor.drag_details = {
            offset_x: offset_x,
            offset_y: offset_y,
            raw_x: x,
            raw_y: y,
            previous_raw_x: x,
            previous_raw_y: y,
            original_width: event.target.clientWidth,
            original_height: event.target.clientHeight,
            drag_type: 'grid',
            data: {
                type: 'grid',
                data: resource
            }
        }
    };

    grid_drag = (resource, event) => {
        return; //temp return
        var x, y;
        if (event.type == "touchmove") {
            x = event.touches[0].pageX;
            y = event.touches[0].pageY;
        } else {
            x = event.pageX;
            y = event.pageY;
        }
        if (window.design_editor.drag_details) {
            window.design_editor.drag_details.raw_x = window.design_editor.drag_details.previous_raw_x
            window.design_editor.drag_details.raw_y = window.design_editor.drag_details.previous_raw_y
            window.design_editor.drag_details.previous_raw_x = x
            window.design_editor.drag_details.previous_raw_y = y
        }

        window.design_editor.style_ghost_image(event.target);

        event.preventDefault();
    };

    grid_drag_end = (resource, event) => {
        return; //temp return
        event.target.style.opacity = 1
        var elem = window.document.getElementById('drag_image');
        if (elem && elem.parentElement) {
            elem.parentElement.removeChild(elem);
        }
        if (window.design_editor.drag_ghost_image && window.design_editor.drag_ghost_image.parentElement) {
            window.design_editor.drag_ghost_image.parentElement.removeChild(window.design_editor.drag_ghost_image);
        }

        window.design_editor.handleDrop(event.target);
        event.preventDefault();
    };

    add_frame = (resource, event) => {
        window.design_editor.addObject({
            type: 'grid',
            sub_type: 'frame',
            grid_details: {
                boxes: [{
                    frame: {
                        type: 'image',
                        image_details: {
                            src: resource.src
                        }
                    },
                    position: {x: 0, y: 0},
                    width: 100,
                    height: 100,
                    loader_image_frame: event.target
                }]
            }
        })
    };

    frame_drag_start = (resource, event) => {
        return; //temp return
        event.dataTransfer.effectAllowed = 'move'
        event.dataTransfer.setData("stringified_data", JSON.stringify(
            )
        );

        var x, y;
        if (event.type == "touchmove") {
            x = event.touches[0].pageX;
            y = event.touches[0].pageY;
        } else {
            x = event.pageX;
            y = event.pageY;
        }

        var offset_x = (x - window.$(event.target).offset().left)
        var offset_y = (y - window.$(event.target).offset().top)


        event.dataTransfer.effectAllowed = 'move';
        event.target.style.opacity = 0

        event.dataTransfer.setDragImage(default_drag_ghost, 0, 0);

        window.design_editor.drag_ghost_image = event.target.cloneNode(true);
        window.design_editor.drag_ghost_image.style.opacity = 0.8
        window.document.body.appendChild(window.design_editor.drag_ghost_image)
        window.design_editor.drag_details = {
            offset_x: offset_x,
            offset_y: offset_y,
            raw_x: x,
            raw_y: y,
            previous_raw_x: x,
            previous_raw_y: y,
            original_width: event.target.clientWidth,
            original_height: event.target.clientHeight,
            drag_type: 'frame',
            data: {
                type: 'frame',
                data: {
                    type: 'grid',
                    sub_type: 'frame',
                    grid_details: {
                        boxes: [{
                            frame: {
                                type: 'image',
                                image_details: {
                                    src: resource.src
                                }
                            },
                            position: {x: 0, y: 0},
                            width: 100,
                            height: 100
                        }]
                    }
                }
            }
        }
    };

    frame_drag = (resource, event) => {
        return; //temp return
        var x, y;
        if (event.type == "touchmove") {
            x = event.touches[0].pageX;
            y = event.touches[0].pageY;
        } else {
            x = event.pageX;
            y = event.pageY;
        }
        if (window.design_editor.drag_details) {
            window.design_editor.drag_details.raw_x = window.design_editor.drag_details.previous_raw_x
            window.design_editor.drag_details.raw_y = window.design_editor.drag_details.previous_raw_y
            window.design_editor.drag_details.previous_raw_x = x
            window.design_editor.drag_details.previous_raw_y = y
        }

        window.design_editor.style_ghost_image(event.target);

        event.preventDefault();
    }

    frame_drag_end = (resource, event) => {
        return; //temp return
        event.target.style.opacity = 1
        var elem = window.document.getElementById('drag_image');
        if (elem && elem.parentElement) {
            elem.parentElement.removeChild(elem);
        }
        if (window.design_editor.drag_ghost_image && window.design_editor.drag_ghost_image.parentElement) {
            window.design_editor.drag_ghost_image.parentElement.removeChild(window.design_editor.drag_ghost_image);
        }

        window.design_editor.handleDrop(event.target);
        event.preventDefault();
    };

    add_element = (resource) => {

        if (resource.sub_type == 'icon') {
            window.design_editor.addObject({
                type: 'image',
                sub_type: 'icon',
                image_details: {
                    src: resource.src
                }
            })
        } else if (resource.sub_type == 'frame') {
            window.design_editor.addObject({
                type: 'grid',
                sub_type: 'frame',
                grid_details: {
                    boxes: [{
                        frame: {
                            type: 'image',
                            image_details: {
                                src: resource.src,
                                id_123rf: resource.id
                            }
                        },
                        position: {x: 0, y: 0},
                        width: 100,
                        height: 100
                    }]
                }
            })
        } else if (resource.design_file) {
            window.design_editor.addObject(resource.design_file)
        }
    };


    handleCategorySelection = (category) => {
        this.setState({
            category: category,
            page: 0,
            data: []
        }, () => this.fetchData(category))
    };

    IconPanel = () => {
        return (
            <div>
                <span style={{
                    marginLeft: 12,
                    marginBottom: 4,
                    'fontSize': '1.2rem',
                    'fontWeight': '600',
                    'float': 'Left',
                    cursor: "pointer"
                }} onClick={() => this.setState({category: 'all'})}>Back</span>
                <br/>
                <InfiniteScroll style={{width: '100%'}}
                                dataLength={this.state.data ? this.state.data.length : 0}
                                next={this.fetchData}
                                hasMore={true}
                                endMessage={<h4>No more results.</h4>}
                                height="calc(100vh - 170px)"
                >
                    <DesignResourcesPanel
                        on_drag_start={this.icon_drag_start}
                        on_drag={this.icon_drag}
                        on_drag_end={this.icon_drag_end}
                        on_click={this.add_icon}
                        image_height={this.state.category === "Lines" ? '252px' : '126px'}
                        col_size={6}
                        resources={this.state.data}/>
                </InfiniteScroll>
            </div>
        );
    };


    SearchBar = () => (
        <div className="nav_content_search_container" style={{padding: 12, paddingTop: 20}}>
            <Form onSubmit={this.handleSearchSubmit}>
                <FormGroup>
                    <InputGroup style={{width: "100%"}}>
                        <FormControl
                            style={{fontSize: 14, fontFamily: 'Montserrat', height: 42, borderRadius: 4}}
                            placeholder={'Search elements'}
                            value={this.state.searchKeywords}
                            type="text"
                            onChange={(e) => this.handleSearchOnChange(e)}
                        />
                        {this.state.searchActive ?
                            (<span onClick={this.handleSearchClear} style={{
                                cursor: 'pointer',
                                position: 'absolute',
                                right: 12,
                                top: 9,
                                fontSize: 22,
                                zIndex: 100,
                                color: '#C8CDD4'
                            }} className="fas fa-times fa-2x fas-light"/>)
                            : (<span onClick={this.handleSearchSubmit} style={{
                                position: 'absolute',
                                cursor: 'pointer',
                                right: 12,
                                top: 9,
                                fontSize: 22,
                                zIndex: 100,
                                color: '#C8CDD4'
                            }} className="fas fa-search fa-2x fas-light"/>)
                        }
                    </InputGroup>
                    <Button style={{'display': 'none'}} type='submit'/>
                </FormGroup>
            </Form>
        </div>
    );

    render() {

        if (this.state.isFetching) return <div/>;

        switch (this.state.category) {

            case "all":
                return (
                    <React.Fragment>
                        <this.SearchBar/>
                        {this.state.searchActive ? (
                            <InfiniteScroll
                                dataLength={this.state.data ? this.state.data.length : 0}
                                next={this.fetchSearchResults}
                                hasMore={true}
                                endMessage={<h4>No more results.</h4>}
                                height={'calc(100vh - 198px)'}
                            >
                                <DesignResourcesPanel
                                    on_drag_start={this.props.image_drag_start}
                                    on_drag={this.props.image_drag}
                                    on_drag_end={this.props.image_drag_end}
                                    on_click={this.props.add_image}
                                    image_height={'126px'}
                                    col_size={6}
                                    resources={this.state.data}/>
                            </InfiniteScroll>
                        ) : (
                            <div className="thin_scroll" style={{width: "100%", height: "calc(100vh - 149px)"}}>
                                <ElementsHomePanel
                                    categories={this.state.elementCategories}
                                    on_drag_start={this.props.image_drag_start}
                                    on_drag={this.props.image_drag}
                                    on_drag_end={this.props.image_drag_end}
                                    on_click={this.props.add_image}
                                    handleCategorySelection={this.handleCategorySelection}
                                />
                            </div>
                        )}
                    </React.Fragment>
                );

            case "frame":
                return (
                    <div>
                        <div style={{height: 20}}/>
                        <span style={{
                            marginLeft: 12,
                            marginBottom: 4,
                            'fontSize': '1.2rem',
                            'fontWeight': '600',
                            'float': 'Left',
                            cursor: "pointer"
                        }} onClick={() => this.setState({category: 'all'})}>Back</span>
                        <br/>
                        <InfiniteScroll style={{width: '100%'}}
                                        dataLength={this.state.data ? this.state.data.length : 0}
                                        next={this.fetchData}
                                        hasMore={true}
                                        endMessage={<h4>No more results.</h4>}
                                        height="calc(100vh - 170px)"
                        >
                            <DesignResourcesPanel
                                on_drag_start={this.frame_drag_start}
                                on_drag={this.frame_drag}
                                on_drag_end={this.frame_drag_end}
                                on_click={this.add_frame}
                                image_height={'126px'}
                                col_size={6}
                                resources={this.state.data}
                            />
                        </InfiniteScroll>
                    </div>
                );

            case "grid":
                return (
                    <React.Fragment>
                        <div style={{height: 20}}/>
                        <div>
                            <span style={{
                                marginLeft: 12,
                                marginBottom: 4,
                                'fontSize': '1.2rem',
                                'fontWeight': '600',
                                'float': 'Left',
                                cursor: "pointer"
                            }} onClick={() => this.setState({category: 'all'})}>Back</span>
                            <br/>
                            <InfiniteScroll style={{width: '100%'}}
                                            dataLength={this.state.data ? this.state.data.length : 0}
                                            next={this.fetchData}
                                            hasMore={true}
                                            endMessage={<h4>No more results.</h4>}
                                            height="calc(100vh - 170px)"
                            >
                                <DesignResourcesPanel
                                    on_drag_start={this.grid_drag_start}
                                    on_drag={this.grid_drag}
                                    on_drag_end={this.grid_drag_end}
                                    on_click={this.add_grid}
                                    image_height={'126px'}
                                    col_size={6}
                                    resources={this.state.data}
                                />
                            </InfiniteScroll>
                        </div>
                    </React.Fragment>
                );

            case "brand_kit":
                return (
                    <React.Fragment>
                        <div style={{height: 20}}/>
                        <div>
                            <span style={{
                                marginLeft: 12,
                                marginBottom: 4,
                                'fontSize': '1.2rem',
                                'fontWeight': '600',
                                'float': 'Left',
                                cursor: "pointer"
                            }} onClick={() => this.setState({category: 'all'})}>Back</span>
                            <br/>
                            <DesignResourcesPanel
                                on_drag_start={this.props.image_drag_start}
                                on_drag={this.props.image_drag}
                                on_drag_end={this.props.image_drag_end}
                                on_click={this.props.add_image}
                                image_height={'126px'}
                                col_size={6}
                                resources={this.state.data}
                            />
                        </div>
                    </React.Fragment>
                );
            default:
                return (
                    <React.Fragment>
                        <this.SearchBar/>
                        {this.state.searchActive ? (
                                <InfiniteScroll
                                    dataLength={this.state.data ? this.state.data.length : 0}
                                    next={this.fetchSearchResults}
                                    hasMore={true}
                                    endMessage={<h4>No more results.</h4>}
                                    height={'calc(100vh - 198px)'}
                                >
                                    <DesignResourcesPanel
                                        on_drag_start={this.icon_drag_start}
                                        on_drag={this.icon_drag}
                                        on_drag_end={this.icon_drag_end}
                                        on_click={this.add_icon}
                                        image_height={'126px'}
                                        col_size={6}
                                        resources={this.state.data}/>
                                </InfiniteScroll>
                            ) :
                            <this.IconPanel/>
                        }
                    </React.Fragment>
                );
        }
    }
}

const mapStateToProps = function (state) {
    return {
        user: state.user
    }
};

const mapDispatchToProps = dispatch => {
    return {
        fetch_teams: () => {
            return dispatch(fetch_teams())
        }
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ElementsPanel));